import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_BaseAdvisorRuntime } from '../../../../modules/ModuleFE_BaseAdvisorRuntime.js';
import { DBDef_RuntimeActiveNavState } from '@app/advisor-shared';
import { ModuleFE_AdvisorSession } from '../../../advisor-session/ModuleFE_AdvisorSession.js';
export const dispatch_onRuntimeActiveNavState = new ThunderDispatcherV3('__onRuntimeActiveNavStateUpdated');
export class ModuleFE_RuntimeActiveNavState_Class extends ModuleFE_BaseAdvisorRuntime {
    constructor() {
        super(DBDef_RuntimeActiveNavState, dispatch_onRuntimeActiveNavState);
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.encounterFilter);
    }
}
export const ModuleFE_RuntimeActiveNavState = new ModuleFE_RuntimeActiveNavState_Class();
//# sourceMappingURL=ModuleFE_RuntimeActiveNavState.js.map